/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Driver_AssignedInputs */

const vi_notif_type_driver_assigned = /** @type {(inputs: Notif_Type_Driver_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao tài xế`)
};

/**

* @param {Notif_Type_Driver_AssignedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_driver_assigned = /** @type {((inputs?: Notif_Type_Driver_AssignedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Driver_AssignedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_driver_assigned(inputs)
});